import AlertForm from "@/components/form/AlertForm"
import ConfirmDeleteForm from "@/components/form/ConfirmDeleteForm"
import ConfirmForm from "@/components/form/ConfirmForm"
import type { Nullable } from "@/models"
import { computed, type ComputedRef } from "vue"
import {
	Alert,
	ConfirmResult,
	createPopups,
	type AlertPopup,
	type Component,
	type ConfirmPopup,
	type Popup,
	type PopupsComposable,
} from "vue-utils"

export { ConfirmResult }
export type { AlertPopup, ConfirmPopup, Popup }

export interface ConfirmDeletePopupOptions {
	title: string
	content: Component

	cancelText?: string
	deleteText?: string
	width?: string
}

export interface SARLogPopups extends PopupsComposable {
	topPopup: ComputedRef<Nullable<Popup>>

	confirmDelete(entityName: string): Promise<boolean>
	confirmDelete(options: ConfirmDeletePopupOptions): Promise<boolean>
}

const popupsData = createPopups({
	AlertPopup: AlertForm,
	ConfirmPopup: ConfirmForm,
})
const topPopup = computed<Nullable<Popup>>(() => {
	const popups = popupsData.popups.value
	return popups.length === 0 ? null : popups[popups.length - 1]
})

async function confirmDelete(options: string | ConfirmDeletePopupOptions): Promise<boolean> {
	if (typeof options === "string") {
		const entityName = options
		return await confirmDelete({
			title: "Confirm Delete",
			content: () => `Are you sure you want to delete this ${entityName}?`,
		})
	}
	return new Promise((resolve) => {
		popupsData.openPopup({
			width: options.width,
			onClose: () => {
				resolve(false)
			},
			content: (popupProps) => (
				<Alert title={options.title}>
					<ConfirmDeleteForm
						onCancel={() => {
							popupProps.close()
							resolve(false)
						}}
						onDelete={() => {
							popupProps.close()
							resolve(true)
						}}
						cancelText={options.cancelText}
						deleteText={options.deleteText}
					>
						<options.content />
					</ConfirmDeleteForm>
				</Alert>
			),
		})
	})
}

const popups: SARLogPopups = {
	...popupsData,
	topPopup,
	confirmDelete,
}

export default function usePopups(): SARLogPopups {
	return popups
}
